import React, { useState, useEffect } from 'react';
import cx from "classnames";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    centerText: {
        textAlign: 'center'
    },
    revenue: {
        color: 'limegreen'
    },
    expense: {
        color: 'red'
    }
}))

const Financials = ({ name, type, val }) => {
    const classes = useStyles();
    const [displayStr, setDisplayStr] = useState(createDisplay);

    const createDisplay = () => {
        switch (type) {
            case 'revenue':
            case 'expense':
                return `$ ${val}`;
            case 'percent':
                return `${val} %`
            default:
                return val;
        }
    }

    useEffect(() => {
        setDisplayStr(createDisplay);
    }, [val, type]);

    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <h5 className={classes.centerText}>
                    {name}
                </h5>
            </GridItem>
            <GridItem xs={12}>
                <p 
                    className={cx({
                        [classes.centerText]: true,
                        [classes.revenue]: type === 'revenue',
                        [classes.expense]: type === 'expense'
                    })}
                >
                    {displayStr}
                </p>
            </GridItem>
        </GridContainer>
    );
}

export default Financials;


// WEBPACK FOOTER //
// ./src/components/TripFinancials/Financials.jsx